/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsProductSection6 = {
  init: function ($section) {
    
    // Add settings from schema to current object
    // window.PXUTheme.jsProductSection6 = $.extend(this, window.PXUTheme.getSectionData($section));

    this.element = $section[0];

    this.delegateElement = new domDelegate.Delegate($section[0]);
    this.domDelegate = new domDelegate.Delegate(document.body);

    this.prevButton = this.element.querySelector("[data-carousel='previous']");
    this.nextButton = this.element.querySelector("[data-carousel='next']");

    this.initCarousel();

    let options = {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    }
    this.observer = new IntersectionObserver(this.scrolledIntoView.bind(this), options);
    this.observer.observe(this.element);
    
    this.setSpaceForNextSection();
  },
  initCarousel() {
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new Swiper(this.carouselElement, {
      grabCursor: true,
      effect: 'creative',
      creativeEffect: {
        limitProgress: 2,
        progressMultiplier: 1,
        shadowPerProgress: true,
        prev: {
          shadow: true,
          translate: ["-125%", 0, 0],
          rotate: [0, 0, 0],
          opacity: 1,
        },
        next: {
          shadow: true,
          translate: ["35%", 0, -200],
          rotate: [0, 0, 0],
          opacity: 0.75,
        },
      },
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      on: {
        slideChange: (swiper) => {
          let prevSlide = swiper.slides[swiper.previousIndex];
          let nextSlide = swiper.slides[swiper.activeIndex];
          let prevSlideVideo = prevSlide.querySelector('.ProductPageVideo');
          let nextSlideVideo = nextSlide.querySelector('.ProductPageVideo');
          prevSlideVideo.pause();
          nextSlideVideo.play();
        }
      }
    });
  },
  scrolledIntoView(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.startVideo();
        this.observer.unobserve(this.element)
      }
    });
  },
  startVideo() {
    let videoWrapper = this.element.querySelector(".swiper-slide-active");
    let video = videoWrapper.querySelector(".ProductPageVideo");
    new Promise((resolve) => {
      if (video.readyState > 2) {
        resolve(video)
      } else {
        let startVideoFn = (event, target) => {
          resolve(video)
          video.removeEventListener("loadeddata", startVideoFn)
        }
        video.addEventListener("loadeddata", startVideoFn);
      }
    })
    .then(video => video.play())
    .catch(error => console.log(error.message));

  },
  setSpaceForNextSection() {
    if( this.element.querySelector(".Section_6--footer.no-overlap") ){
      return false;
    }
    
    let getSpace = () => {
      let footer = this.element.querySelector(".Section_6--footer");
      let space = footer.clientHeight / 2;
      return space;
    }
    let space = getSpace();
    let targetSection = this.element.nextElementSibling.querySelector("section");
    let spaceContainer = document.createElement("div");
    spaceContainer.classList.add("spaceContainer");
    spaceContainer.style.height = `${space}px`;
    targetSection.firstChild.before(spaceContainer);

    window.addEventListener("resize", () => {
      let space = getSpace();
      spaceContainer.style.height = `${space}px`;
    });

  }
}

/******/ })()
;